"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterOutOfStock = function (products) { var _a; return (_a = products) === null || _a === void 0 ? void 0 : _a.filter(function (product) { var _a, _b; return !((_b = (_a = product) === null || _a === void 0 ? void 0 : _a.tags) === null || _b === void 0 ? void 0 : _b.includes("visibility:out-of-stock")); }); };
